import { GetterTree } from 'vuex';
import { IRootState } from '@/store/state';
import Snackbar from '@/models/Snackbar';
import { Template } from '@/modules/amDashboard/types';

/**
 * --------------------------------------------------
 *	Root Getters
 * --------------------------------------------------
 **/
export const RootGetters: IRootGettersTree = {
  snackbar: (state: IRootState): Snackbar | null => state.snackbar,
  globalSource: (state: IRootState): string => state.globalSource,
  bulkSubmissionTemplateDetails: (state: IRootState): Template[] =>
    state.bulkSubmissionTemplateDetails,
  batchId: (state: IRootState): string => state.batchId,
  validatingEntityAccess: (state: IRootState): boolean =>
    state.validatingEntityAccess
};
/**
 * --------------------------------------------------
 *	Root Getter (Tree) Interface
 * --------------------------------------------------
 **/
export interface IRootGettersTree extends GetterTree<IRootState, IRootState> {
  snackbar: (state: IRootState) => Snackbar | null;
  globalSource: (state: IRootState) => string;
  bulkSubmissionTemplateDetails: (state: IRootState) => Template[];
  batchId: (state: IRootState) => string;
  validatingEntityAccess: (state: IRootState) => boolean;
}
